import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, vModelRadio as _vModelRadio, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/course-cari.jpg'


const _withScopeId = n => (_pushScopeId("data-v-0ef88fba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "col-10 col-lg-4 p-3 bg-light custom-modal m-auto rounded-3 mt-5" }
const _hoisted_2 = { class: "row pt-3" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "Vous souhaitez procéder au paiement ? 💰")
], -1))
const _hoisted_4 = { class: "col-1" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-icons-outlined" }, " close ", -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div class=\"row m-2 pt-3\" data-v-0ef88fba><div class=\"col bg-primary text-start text-light rounded pt-3 mx-3\" data-v-0ef88fba><p data-v-0ef88fba> Le paiement s&#39;effectue sur <a href=\"https://www.helloasso.com/\" data-v-0ef88fba>HelloAsso</a>, une plateforme externe. Si vous constatez une erreur dans les informations de paiement (course, tarif VAvantages ou non,...), vous pouvez nous contacter à l&#39;adresse <a href=\"mailto:overrun@24heures.org\" data-v-0ef88fba>overrun@24heures.org</a> indiquant </p><ul class=\"ms-5\" data-v-0ef88fba><li class=\"fw-bold\" data-v-0ef88fba>Votre pseudo</li><li class=\"fw-bold\" data-v-0ef88fba>Votre nom</li><li class=\"fw-bold\" data-v-0ef88fba>Votre prénom</li><li class=\"fw-bold\" data-v-0ef88fba>Les informations qui vous semblent erronées</li></ul></div></div>", 1)
const _hoisted_8 = { class: "d-flex flex-column justify-content-center align-items-center" }
const _hoisted_9 = { class: "table table-striped table-bordered mt-5" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Détail"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Quantité"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Prix unitaire"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Prix total")
  ])
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "1", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Don pour la course caritative", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "1", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "2",
  class: "table-active"
}, [
  /*#__PURE__*/_createElementVNode("strong", null, "Total")
], -1))
const _hoisted_15 = { colspan: "2" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Logo de l'association Le coeur et la Main",
  height: "120"
}, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Je souhaite faire un don pour la course caritative ("),
  /*#__PURE__*/_createElementVNode("a", {
    href: "http://www.coeuretlamain.fr",
    target: "_blank"
  }, "Plus d'informations"),
  /*#__PURE__*/_createTextVNode(") ")
], -1))
const _hoisted_18 = { class: "form-check d-flex justify-content-center" }
const _hoisted_19 = { class: "form-check" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "flexCheckDefault"
}, "Oui ", -1))
const _hoisted_21 = { class: "form-check ms-4" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "flexCheckDefault"
}, "Non ", -1))
const _hoisted_23 = { class: "form-check d-flex justify-content-center" }
const _hoisted_24 = { class: "form-check" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Je donne :", -1))
const _hoisted_26 = { class: "form-check d-flex" }
const _hoisted_27 = { class: "form-check" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label me-2",
  for: "flexCheckDefault"
}, " 1 € ", -1))
const _hoisted_29 = { class: "form-check" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label me-2",
  for: "flexCheckDefault"
}, " 5 € ", -1))
const _hoisted_31 = { class: "form-check" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label me-2",
  for: "flexCheckDefault"
}, " 10 € ", -1))
const _hoisted_33 = { class: "form-check" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label me-2",
  for: "flexCheckDefault"
}, " 25 € ", -1))
const _hoisted_35 = { class: "form-check" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label me-2",
  for: "flexCheckDefault"
}, " 50 € ", -1))
const _hoisted_37 = { class: "form-check" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label me-2",
  for: "flexCheckDefault"
}, " Autre ", -1))
const _hoisted_39 = { class: "form-check d-flex" }
const _hoisted_40 = ["value"]
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "input-group-text",
  id: "basic-addon1"
}, "€", -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row m-2 pt-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col bg-primary text-start text-light rounded pt-3 mx-3" }, [
    /*#__PURE__*/_createElementVNode("p", null, [
      /*#__PURE__*/_createTextVNode(" Durant les 24 heures de courses, nous soutenons l’association "),
      /*#__PURE__*/_createElementVNode("strong", null, "Le Cœur et la Main"),
      /*#__PURE__*/_createTextVNode(" , créée en 2017 par 11 membres fondateurs liés par leur amitié. Réunis tout d’abord sous le nom « Le mercredi c’est surimi », leur objectif était à l’époque de réunir des fonds pour organiser une kermesse en faveur de personnes issues de milieux précaires. L’association a maintenant grandi et accueille de nouveaux membres enthousiastes et de nouveaux projets solidaires. ")
    ]),
    /*#__PURE__*/_createElementVNode("p", null, [
      /*#__PURE__*/_createTextVNode(" L'association récolte des financements par l’organisation d’évènements ponctuels (marchés participatifs, concerts solidaires, vente d’objets d’arts…) et par des donations et du crowfunding (collecte d’apports financiers de particuliers au moyen d’une plateforme Internet). Aujourd’hui, "),
      /*#__PURE__*/_createElementVNode("strong", null, "Le Cœur et la Main"),
      /*#__PURE__*/_createTextVNode(" s’évertue à soutenir des projets sociaux lyonnais pour protéger les plus vulnérables et a étendu son champ d’intervention à des missions à l’étranger, encore et toujours portées par ses membres. ")
    ]),
    /*#__PURE__*/_createElementVNode("p", null, [
      /*#__PURE__*/_createTextVNode(" Pour plus d'informations, visitez leur site : "),
      /*#__PURE__*/_createElementVNode("a", {
        href: "http://www.coeuretlamain.fr",
        target: "_blank"
      }, "http://www.coeuretlamain.fr")
    ]),
    /*#__PURE__*/_createElementVNode("p", null, " Si vous aussi vous voulez apportez votre soutien, alors n’hésitez pas à faire don du montant que vous souhaitez lors de vos inscriptions ! Nous vous remercions pour votre geste 💙 ")
  ])
], -1))
const _hoisted_43 = { class: "mt-5 d-flex justify-content-around align-items-center flex-wrap" }
const _hoisted_44 = ["disabled"]
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Procéder au paiement", -1))
const _hoisted_46 = [
  _hoisted_45
]
const _hoisted_47 = ["disabled"]
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Obtenir un nouveau lien", -1))
const _hoisted_49 = [
  _hoisted_48
]
const _hoisted_50 = { class: "btn btn-lg btn-primary mx-5" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "spinner-border",
  role: "status"
}, null, -1))
const _hoisted_52 = [
  _hoisted_51
]
const _hoisted_53 = { class: "btn btn-lg btn-primary mx-5" }
const _hoisted_54 = ["href"]
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  "aspect-ratio": "1",
  class: "size-one-em",
  src: "https://backoffice.helloasso.com/Assets/dist/img/helloasso-badge.svg"
}, null, -1))
const _hoisted_56 = { class: "ms-2 m-0 p-0" }
const _hoisted_57 = { class: "error" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "backdrop overflow-scroll",
    onClick: _cache[12] || (_cache[12] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)), ["self"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            id: "close-arrow",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
          }, _hoisted_6)
        ])
      ]),
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", null, [
          _createElementVNode("table", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("td", null, _toDisplayString(_ctx.payment?.inscription?.race?.name), 1),
                _hoisted_11,
                _createElementVNode("td", null, _toDisplayString(_ctx.centimesToEuro(_ctx.payment.raceAmount)) + "€", 1),
                _createElementVNode("td", null, _toDisplayString(_ctx.centimesToEuro(_ctx.payment.raceAmount)) + "€", 1)
              ]),
              _withDirectives(_createElementVNode("tr", null, [
                _hoisted_12,
                _hoisted_13,
                _createElementVNode("td", null, _toDisplayString(_ctx.centimesToEuro(_ctx.payment.donationAmount)) + "€", 1),
                _createElementVNode("td", null, _toDisplayString(_ctx.centimesToEuro(_ctx.payment.donationAmount)) + "€", 1)
              ], 512), [
                [_vShow, _ctx.wantToDonate]
              ])
            ]),
            _createElementVNode("tfoot", null, [
              _createElementVNode("tr", null, [
                _hoisted_14,
                _createElementVNode("td", _hoisted_15, _toDisplayString(_ctx.computeTotalAmount()) + "€ TTC", 1)
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("form", null, [
          _hoisted_16,
          _hoisted_17,
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _hoisted_20,
              _withDirectives(_createElementVNode("input", {
                class: "form-check-input",
                type: "radio",
                name: "flexRadioDefault",
                id: "donationYes",
                value: true,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.wantToDonate) = $event))
              }, null, 512), [
                [_vModelRadio, _ctx.wantToDonate]
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _hoisted_22,
              _withDirectives(_createElementVNode("input", {
                class: "form-check-input",
                type: "radio",
                name: "flexRadioDefault",
                id: "donationNo",
                value: false,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.wantToDonate) = $event))
              }, null, 512), [
                [_vModelRadio, _ctx.wantToDonate]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _withDirectives(_createElementVNode("div", _hoisted_24, [
              _hoisted_25,
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _hoisted_28,
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "radio",
                    name: "donationAmount",
                    id: "donationOneEuro",
                    value: 100,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.payment.donationAmount) = $event))
                  }, null, 512), [
                    [_vModelRadio, _ctx.payment.donationAmount]
                  ])
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _hoisted_30,
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "radio",
                    name: "donationAmount",
                    id: "donationTwoEuro",
                    value: 500,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.payment.donationAmount) = $event))
                  }, null, 512), [
                    [_vModelRadio, _ctx.payment.donationAmount]
                  ])
                ]),
                _createElementVNode("div", _hoisted_31, [
                  _hoisted_32,
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "radio",
                    name: "donationAmount",
                    id: "donationTenEuro",
                    value: 1000,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.payment.donationAmount) = $event))
                  }, null, 512), [
                    [_vModelRadio, _ctx.payment.donationAmount]
                  ])
                ]),
                _createElementVNode("div", _hoisted_33, [
                  _hoisted_34,
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "radio",
                    name: "donationAmount",
                    id: "donationTwentyFiveEuro",
                    value: 2500,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.payment.donationAmount) = $event))
                  }, null, 512), [
                    [_vModelRadio, _ctx.payment.donationAmount]
                  ])
                ]),
                _createElementVNode("div", _hoisted_35, [
                  _hoisted_36,
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "radio",
                    name: "donationAmount",
                    id: "donationFiftyEuro",
                    value: 5000,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.payment.donationAmount) = $event))
                  }, null, 512), [
                    [_vModelRadio, _ctx.payment.donationAmount]
                  ])
                ]),
                _createElementVNode("div", _hoisted_37, [
                  _hoisted_38,
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "checkbox",
                    name: "otherDonationAmount",
                    id: "otherDonationAmount",
                    value: true,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.otherDonationAmount) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.otherDonationAmount]
                  ])
                ])
              ]),
              _withDirectives(_createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("input", {
                    type: "number",
                    min: "0",
                    max: "1000",
                    class: "form-control",
                    placeholder: "Montant",
                    "aria-describedby": "basic-addon1",
                    value: _ctx.centimesToEuro(_ctx.payment.donationAmount),
                    onInput: _cache[9] || (_cache[9] = 
                      (event) =>
                        (_ctx.payment.donationAmount = _ctx.euroToCentimes(
                          // @ts-ignore
                          event.target.value
                        ))
                    )
                  }, null, 40, _hoisted_40),
                  _hoisted_41
                ])
              ], 512), [
                [_vShow, _ctx.otherDonationAmount]
              ])
            ], 512), [
              [_vShow, _ctx.wantToDonate]
            ])
          ])
        ])
      ]),
      _hoisted_42,
      _createElementVNode("div", _hoisted_43, [
        _createElementVNode("div", null, [
          _withDirectives(_createElementVNode("button", {
            class: "btn btn-lg btn-primary mx-5",
            onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.getHelloassoRedirectLink && _ctx.getHelloassoRedirectLink(...args))),
            disabled: _ctx.wantToDonate === null
          }, _hoisted_46, 8, _hoisted_44), [
            [_vShow, !_ctx.loading && _ctx.payment?.helloassoCheckoutIntentUrl === null]
          ]),
          _withDirectives(_createElementVNode("button", {
            class: "btn btn-lg btn-primary mx-5",
            onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.updateMyPaymentWithNewDonationAmount && _ctx.updateMyPaymentWithNewDonationAmount(...args))),
            disabled: _ctx.wantToDonate === null
          }, _hoisted_49, 8, _hoisted_47), [
            [_vShow, !_ctx.loading && _ctx.isNecessaryToUpdatePayment]
          ]),
          _withDirectives(_createElementVNode("button", _hoisted_50, _hoisted_52, 512), [
            [_vShow, _ctx.loading]
          ]),
          _withDirectives(_createElementVNode("button", _hoisted_53, [
            _createElementVNode("span", null, [
              _createElementVNode("a", {
                href: _ctx.payment.helloassoCheckoutIntentUrl,
                class: "btn btn-primary d-flex align-items-center"
              }, [
                _hoisted_55,
                _createElementVNode("p", _hoisted_56, "Payer " + _toDisplayString(_ctx.computeTotalAmount()) + "€", 1)
              ], 8, _hoisted_54)
            ])
          ], 512), [
            [_vShow, 
              !_ctx.loading &&
              _ctx.payment.helloassoCheckoutIntentUrl &&
              !_ctx.isNecessaryToUpdatePayment
            ]
          ])
        ]),
        _createElementVNode("p", _hoisted_57, _toDisplayString(_ctx.errorMsg), 1)
      ])
    ])
  ]))
}